import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 2rem;
	background: #fff;
	box-shadow: 0 6px 24px 0 rgba(0, 0, 0,0.22);
	width: 23.8rem;
`;
